module.exports = __webpack_public_path__ + "img/p-single-7.afd4642a.jpg";